<label class="im:card portal" [class.disabled]="isDisabled">
  <span class="logo">
    <img src="{{ config()?.imgUrl }}" alt="" />
  </span>

  <span class="info">
    <span class="im:body name">
      {{ config()?.fullName | translate }}
      @if (credential() && credential().portal !== 'EBAY') {
        <span> - {{ credential().name }}</span>
      }
    </span>
    @if (credential()) {
      <span class="im:caption user">
        {{
          !isImmoscout
            ? ('portals.username_password_used_l' | translate)
            : ('portals.token_used_l' | translate)
        }}
      </span>
    }
  </span>

  @if (selectable() && deselectable()) {
    <span class="checkbox">
      <input
        type="checkbox"
        class="im:checkbox-input"
        [formControl]="checkControl"
        [attr.disabled]="disabled() ? '' : null"
      />
    </span>
  }
  @if (!deselectable()) {
    <span class="checkbox" [imTooltip]="blockTooltip" position="top">
      <input
        type="checkbox"
        class="im:checkbox-input"
        [formControl]="checkControl"
        [attr.disabled]="disabled() || !deselectable() ? '' : null"
      />
    </span>
  }
  @if (removable()) {
    <!-- preventDefault keeps the remove click from toggling the label -->
    <button
      im-button
      class="inverted remove"
      (click)="$event.preventDefault(); onRemove()"
      imTooltip="{{ 'REMOVE_PORTAL_A' | translate }}"
      [openDelay]="1000"
    >
      <i iconStart class="icon icon--delete"></i>
    </button>
  }
</label>

<ng-template #blockTooltip>
  <span>{{ 'BLOCKED_PORTALS_DESELECT_M' | translate }}</span>
</ng-template>
